"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ButtonContent;

function ButtonContent(_ref) {
  var label = _ref.label,
      children = _ref.children;
  return children || label || null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Button/buttonContent.js
// module id = GP1m
// module chunks = 0